import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import DayJs from 'utils/Dayjs';
import { ARTICLE_STATES } from 'utils/Constants';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import { Title } from 'components/Misc/Typography';

const className = classnames(
	'py-3 px-4 flex flex-col space-y-2 ring-amber-500 rounded-lg cursor-pointer transition-all',
	'bg-white dark:bg-neutral-800',
	'hover:ring focus:ring',
);

const Article = ({ article }) => {
	// Find status info
	const status = useMemo(() => ARTICLE_STATES.find(status => status.value === article.status), [article.status]);

	const statusClassName = classnames(
		'flex items-center space-x-1 text-sm',
		article?.status === 'visible' && 'text-emerald-500',
		article?.status === 'hidden' && 'text-amber-500'
	);

	return (
		<Link
			to={`/articles/${article.id}`}
			className={className}
		>
			<Title
				title={article.title}
				subtitle={DayJs(article.createdAt).format('D. MMM, YYYY')}
			/>

			<Show if={article?.thumbnail}>
				<img
					alt={article?.thumbnail}
					src={`${process.env.REACT_APP_CDN}/articles/${article?.slug}/${article?.thumbnail}`}
					className="mx-auto max-w-full max-h-44 rounded-lg"
				/>
			</Show>

			<div className="flex flex-wrap gap-2">
				<Show if={article.availableFrom}>
					<div className="flex items-center space-x-1">
						<Icon icon="today" className="text-base text-neutral-500 dark:text-neutral-400" />
						<div className="text-xs text-neutral-500 dark:text-neutral-400">{DayJs(article.availableFrom).format('D. MMM, YYYY')}</div>
					</div>
				</Show>

				<Show if={article.availableUntil}>
					<div className="flex items-center space-x-1">
						<Icon icon="event" className="text-base text-neutral-500 dark:text-neutral-400" />
						<div className="text-xs text-neutral-500 dark:text-neutral-400">{DayJs(article.availableUntil).format('D. MMM, YYYY')}</div>
					</div>
				</Show>

				<div className={statusClassName}>
					<Icon icon="visibility" className="text-base" />
					<div className="text-xs">{status?.text}</div>
				</div>
			</div>

			<div className="text-neutral-700 dark:text-white transition-colors">
				{article.description}
			</div>
		</Link>
	);
};

export default Article;
